import React, { useRef, useState } from 'react';
import {
    GECKO_CONSTS,
    GeckoBtn,
    GeckoFields,
    GeckoModalService,
} from '@geckolabs/gecko-react-ui';

const ACTION_OPTIONS = [
    { value: 'on', label: 'On' },
    { value: 'off', label: 'Off' },
];

const findSelectedOption = (options, selectedValue) => (
    options.find((option) => String(option.value) === String(selectedValue))
);

export default function ToggleDomainSso({ identityProviderOptions = [], onSubmit }) {
    const [selectedValue, setSelectedValue] = useState(identityProviderOptions[0]?.value || '');
    const [action, setAction] = useState('on');
    const selectedOptionRef = useRef(findSelectedOption(identityProviderOptions, selectedValue));

    const selectedOption = findSelectedOption(identityProviderOptions, selectedValue);

    const fields = [
        {
            key: 'selectedValue',
            label: 'Identity provider',
            type: GECKO_CONSTS.FIELD_TYPE_SELECT,
            width: '100%',
            required: true,
            optionValueKey: 'value',
            optionsLabelKey: 'label',
            options: identityProviderOptions.map(({ value, label }) => ({ value, label })),
        },
        {
            key: 'action',
            label: 'Action',
            type: GECKO_CONSTS.FIELD_TYPE_SELECT,
            width: '100%',
            required: true,
            optionValueKey: 'value',
            optionsLabelKey: 'label',
            options: ACTION_OPTIONS,
        },
    ];

    const values = { selectedValue, action };

    const handler = (key, value) => {
        if (key === 'selectedValue') {
            setSelectedValue(value);
            selectedOptionRef.current = findSelectedOption(identityProviderOptions, value);
        }

        if (key === 'action') {
            setAction(value);
        }
    };

    const submit = () => {
        const option = selectedOptionRef.current
            ?? findSelectedOption(identityProviderOptions, selectedValue);

        if (!option?.idpId || !action) {
            return;
        }

        return onSubmit(option.idpId, action, option);
    };

    return (
        <div>
            <div className="p-3">
                <p className="text-muted mb-3">
                    {action === 'off'
                        ? 'Disable SSO for all users with an email address at the selected identity provider.'
                        : 'Enable SSO for all users with an email address at the selected identity provider.'}
                </p>
                <p className="text-muted mb-3">
                    <strong>Disclaimer:</strong> This will toggle SSO {action} for all users with that domain on their email, regardless of which account they are associated with.
                </p>
                <GeckoFields fields={fields} values={values} handler={handler} />
                {selectedOption?.provider && (
                    <p className="text-muted mb-0 mt-3">
                        Auth provider: <strong>{selectedOption.provider}</strong>
                    </p>
                )}
            </div>
            <div className="modal-footer d-flex justify-content-end">
                <GeckoBtn
                    name="Cancel"
                    className="btn-default mr-2"
                    handler={() => new GeckoModalService().close()}
                />
                <GeckoBtn
                    name={action === 'off' ? 'Disable SSO' : 'Enable SSO'}
                    className="btn-primary"
                    handler={submit}
                />
            </div>
        </div>
    );
}
